//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { StudentDisplayItem } from './StudentDisplayItem';
import { FamilyDisplayItem } from './FamilyDisplayItem';
import { TaxDisplayItem } from './TaxDisplayItem';
import { RepeatDetailsItem } from './RepeatDetailsItem';
import { TransactionType, TransactionSource } from './Enums';

export class TransactionDisplayItem extends ItemBase {
    Type: TransactionType = TransactionType.Payment;
    Date: string = "1970-01-01T00:00:00";
    DisplayDescription: string | null = null;
    Description: string | null = null;
    Method: string | null = null;
    AccountBalance: number | null = null;
    Charge: number | null = null;
    SalesTax: number | null = null;
    HasTax: boolean = false;
    ChargeWithTax: number | null = null;
    Payment: number | null = null;
    ID: string | null = null;
    EventID: string | null = null;
    PackageMinutesID: string | null = null;
    CategoryID: string | null = null;
    StudentID: string | null = null;
    Student: StudentDisplayItem | null = null;
    FamilyID: string | null = null;
    Family: FamilyDisplayItem | null = null;
    TeacherID: string | null = null;
    HasCash: boolean = false;
    Taxes: TaxDisplayItem[] = [];
    Editable: boolean = false;
    RepeatDetails: RepeatDetailsItem | null = null;
    ManualRecurring: boolean = false;
    Source: TransactionSource = TransactionSource.Manual;

    constructor(initializer?: Partial<TransactionDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TransactionDisplayItem";
}
